// extracted by mini-css-extract-plugin
export default {"imageWrapper":"IG-z","twoColumnImage":"JG-z"};